<template>
  <section>
    <!-- Componentes externos -->

    <v-card>
      <v-card-text>
        <!-- <v-tooltip bottom>
            <v-btn
              slot="activator"
              color="orange"
              dark
              @click.native="enviarMensaje()"
              icon
            >
              <v-icon>mail</v-icon>
            </v-btn>
            <span>Enviar Correo</span>
          </v-tooltip> -->
        <crud-table
          class="tabla-comprimida-light"
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que considere necesarias -->
            <td class="text-xs-center">{{ items.item.nro_doc }}</td>
            <td class="text-xs-center">{{ items.item.item }}</td>
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.unidad }}</td>
            <td class="text-xs-center">{{ items.item.fecha_ingreso }}</td>
            <td class="text-xs-center">
              <v-chip
                :color="
                  items.item.activo_pasivo.split('|')[1] == 'Activo'
                    ? 'success'
                    : 'error'
                "
                text-color="white"
                >{{
                  items.item.activo_pasivo.split("|")[1] == "Activo"
                    ? "Activo"
                    : "Inactivo"
                }}</v-chip
              >
              <!-- <v-chip
                  color="success"
                  text-color="white"
                  v-if="items.item.id_estado === 1"
                  >{{ items.item.estado }}</v-chip
                >
                <v-chip
                  color="error"
                  text-color="white"
                  v-if="items.item.id_estado === 32"
                  >{{ items.item.estado }}</v-chip
                >
                <v-chip
                  color="error"
                  text-color="white"
                  v-if="items.item.id_estado === 2"
                  >{{ items.item.estado }}</v-chip
                >
                <v-chip
                  color="orange"
                  text-color="white"
                  v-if="items.item.id_estado === 5"
                  >{{ items.item.estado }}</v-chip
                > -->
            </td>
            <!-- <v-tooltip bottom v-if="items.item.id_estado === 1"> -->
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  color="blue"
                  dark
                  :to="`/movilidad/${items.item.id_persona}`"
                  icon
                >
                  <v-icon>refresh</v-icon>
                </v-btn>

                <span>Movilidad</span>
              </v-tooltip>
              <v-tooltip bottom v-if="items.item.id_estado === 5">
                <v-btn
                  slot="activator"
                  color="orange"
                  dark
                  @click.native="aprobarMovilidad(items.item)"
                  icon
                >
                  <v-icon>check</v-icon>
                </v-btn>
                <span>Aprobar</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="400" persistent>
      <v-card color="#385F73" dark>
        <v-card-text>
          <v-layout wrap>
            <v-flex>
              <v-list-tile-content>
                <v-list-tile-title
                  ><p color="red">
                    {{ respuestaFuncion[0] }}
                  </p></v-list-tile-title
                >

                <v-list-tile-title
                  ><p>{{ respuestaFuncion[1] }}</p></v-list-tile-title
                >
                <v-list-tile-title
                  ><p>{{ respuestaFuncion[2] }}</p></v-list-tile-title
                >
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click.prevent="close()">
            <v-icon>
              clear
            </v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearPersona from "../dialogs/CrearPersona"; // Componente de creación y actualización
import EditarPersona from "../dialogs/EditarPersona"; // Componente de Editar persona
import AprobarMovilidad from "../dialogs/AprobarMovilidad"; // Componente de Aprobar Movilidad persona

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  props: {
    l_id_tipo_persona: {
      type: Array,
      default: null
    }
  },
  // Variables iniciales del componente
  data() {
    return {
      url: "vListaPersonals",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Ítem", value: "item", align: "center" },
        { text: "Nombre completo", value: "nombre", align: "center" },
        { text: "Unidad", value: "unidad", align: "center" },
        {
          text: "Fecha de incorporación",
          value: "fecha_ingreso",
          align: "center"
        },
        { text: "Estado", value: "id_estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
          id_persona
          id_estado
          nro_doc
          nro_complemento
          item
          nombre
          unidad
          fecha_ingreso
          cargo
          id_cargo
          id_puesto
          id_item
          id_unidad
          id_movilidad
          estado
          activo_pasivo
        `,
      initData: [
        {
          state: true,
          param: "l_tipo_persona",
          value: this.l_id_tipo_persona
        }
      ],
      filters: [
        {
          field: "nro_doc",
          label: "Número de documento",
          type: "text",
          typeG: "String"
        },
        {
          field: "item",
          label: "Ítem",
          type: "number",
          typeG: "String"
        },
        {
          field: "nombre",
          label: "Nombre completo",
          type: "text",
          typeG: "String"
        },
        {
          field: "unidad",
          label: "Unidad",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_ingreso",
          label: "Fecha de incorporación",
          type: "text",
          typeG: "String"
        },
        {
          field: "activo_pasivo",
          label: "Estado",
          type: "text",
          typeG: "String"
        }
      ],
      respuestaFuncion: ["usuario", "correo", "contraseña"],
      respuestaFuncion1: ["usuario", "correo", "contraseña"],
      dialog: false
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
   // const rolesPermitidos = [84]; // ID's de roles permitidos (84:Molivilidad RRHH)
    this.onFilter();
    // if (!this.$util.permisoRol(rolesPermitidos)) {
    //   this.$router.push("/403");
    // }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogCreado", item => {
      this.respuestaFuncion = item.split("-");
      this.dialog = true;
    });
  },
  // Métodos y funciones del componente
  methods: {
    movilidad(item) {
      this.$bus.$emit("openDialogMovilidad", item);
    },
    editarPersona(item) {
      this.$bus.$emit("openDialogEditarPersona", item);
    },
    aprobarMovilidad(item) {
      this.$bus.$emit("openDialogAprobarMovilidad", item);
    },
    crearPersona() {
      this.$bus.$emit("openDialogCrearPersona");
    },
    close() {
      this.respuestaFuncion = [];
      this.dialog = false;
    },

    async enviarMensaje() {
      let correo = await this.getMail();
      const token = this.$storage.get("token");
      const url = process.env.API_URL + "system/sendmail";
      //console.log(correo)
      correo.forEach(async element => {
        //  console.log(element.correo)
        try {
          let body = {
            mail: element.correo,
            asunto: "Recordatorio Movilidad",
            message: element.cuerpo //this.form.observacion,
          };

          const options = {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          };

          var data = await fetch(url, options);
          data = await data.json();
          if (data.mensaje == "Success") {
            this.$message.success("Se envio el correo");
          } else {
            this.$message.error(data.mensaje);
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    async getMail() {
      try {
        let res = await this.$service.graphql({
          query: `
                      query{
                  vVenceInterinatos{
                    rows{
                      id
                      id_usuario
                      id_persona
                      fecha_hasta
                      correo
                      cuerpo
                      
                    }
                  }
                }
                  `
        });
        //return res.persona.usuarios[0].correo;

        this.correosDisponibles = res.vVenceInterinatos.rows;
        this.loading = false;
        return this.correosDisponibles;
      } catch (err) {
        console.log(err);
      }
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearPersona,
    EditarPersona,
    AprobarMovilidad
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/ListadoMovilidad.vue